import Vue from 'vue'
import VueRouter, { Route } from 'vue-router'
import CONSTANTS from '@/constants'
import { sendToHubspot } from '@/utils'
import routes from './routes'
import store from '../store'

Vue.use(VueRouter)

const Router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior: (to: Route, from: Route, savedPosition) => {
    if (savedPosition) {
      return savedPosition
    }
    if (to.hash) {
      return {
        selector: to.hash,
      }
    }
    return { x: 0, y: 0 }
  },
  routes,
})

Router.afterEach((to, from) => {
  sendToHubspot(to.fullPath)
})

Router.beforeResolve((to: Route, from: Route, next: Function) => {
  const hasShopped = store.state.shoppingCart.shoppingCart.length > 0

  if (!hasShopped && to && to.name && CONSTANTS.ROUTING_RULES.MUST_HAVE_SHOPPED.includes(to.name)) {
    next({ name: 'shop' })
  } else {
    next()
  }
})

export default Router
